import { OPEN_MODAL, CLOSE_MODAL } from '../variables'

export default {
	state: {
		modalOpen: false,
		modalContent: null
	},
	getters: {
		modalOpen: state => state.modalOpen,
		modalContent: state => state.modalContent
	},
	actions: {
		[OPEN_MODAL]: ({ commit, dispatch }, content) => {
			commit(OPEN_MODAL, content)
		},
		[CLOSE_MODAL]: ({ commit, dispatch }, message) => {
			commit(CLOSE_MODAL)
		}
	},
	mutations: {
		[OPEN_MODAL]: (state, content) => {
			state.modalContent = content
			state.modalOpen = true
		},
		[CLOSE_MODAL]: (state) => {
			state.modalContent = null
			state.modalOpen = false
		}
	}
}


// WEBPACK FOOTER //
// ./src/store/modal.js